import React from 'react';
import { DelayedLoader } from '../../../../../Loader';
import { DeviceType } from '../../../../../../types/DeviceType';
import { DH } from '../../../../../../utils/DataHook';
import * as s from './styles.scss';

export interface MoreInfoIframeProps {
  src: string;
  deviceType?: DeviceType;
}

export interface MoreInfoIframeState {
  isLoading: boolean;
}

export class MoreInfoIframe extends React.Component<
  MoreInfoIframeProps,
  MoreInfoIframeState
> {
  state: MoreInfoIframeState = {
    isLoading: true,
  };

  handleContentLoaded = () => {
    this.setState({
      isLoading: false,
    });
  };

  render() {
    const { src, deviceType } = this.props;
    return (
      <div className={s.root}>
        {this.state.isLoading && (
          <div className={s.loaderContainer}>
            <DelayedLoader delay={500} />
          </div>
        )}
        <iframe
          data-hook={DH.PaymentMethod.Wallet.StaticInstallment.MoreInfo}
          className={s.iframe}
          width="100%"
          height="100%"
          frameBorder="0"
          scrolling={deviceType === 'mobile' ? 'auto' : 'no'}
          src={src}
          onLoad={this.handleContentLoaded}
        />
      </div>
    );
  }
}
